export default "__VITE_ASSET__BmGAtWaR__";